export enum CustomerType {
    MEARSK = 'mearsk',
    NON_MEARSK = 'non-mearsk'
}
